import { render, staticRenderFns } from "./Safe.vue?vue&type=template&id=5d4f7f3e&scoped=true"
import script from "./Safe.vue?vue&type=script&lang=js"
export * from "./Safe.vue?vue&type=script&lang=js"
import style0 from "./Safe.vue?vue&type=style&index=0&id=5d4f7f3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f7f3e",
  null
  
)

export default component.exports